import { render, staticRenderFns } from "./AirQualityView.vue?vue&type=template&id=3c3c818c&"
import script from "./AirQualityView.vue?vue&type=script&lang=js&"
export * from "./AirQualityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports